import { AnyAction } from 'redux';
import { HIDE_LOADING } from '../action-types';

export type HideLoading = () => AnyAction;
export const hideLoadingAction: HideLoading = () => ({
    type: HIDE_LOADING,
});
